import React from 'react';
import CustomRadio from '../../../common/components/CustomRadio';
import CustomSelect from '../../../common/components/CustomSelect';
import { FieldValidationErrorsType } from '../../../common/form/FrekulForm';

/**
 * 歌詞情報入力
 */
export default function MusicAlbumEditForm3EditPopupViewLyricsInput({
  getValue,
  setValue,
  getErrors,
} : {
  getValue: (name: 'is_inst'|'is_adult'|'language') => string,
  setValue: (name: 'is_inst'|'is_adult'|'language', value: string) => void,
  getErrors: (name: 'is_inst'|'is_adult'|'language') => FieldValidationErrorsType,
}) {
  const isInstOptions = [
    { title: 'YES', value: '0' },
    { title: 'NO', value: '1' },
  ];
  const isAdultOptions = [
    { title: 'YES', value: '1' },
    { title: 'NO', value: '0' },
  ];
  const languageOptions = [
    '日本語',
    '英語',
    '韓国語',
    '北京語',
    '台湾語',
    '広東語',
    'イタリア語',
    'フランス語',
    'ポルトガル語',
    'ドイツ語',
    'スペイン語',
    'ロシア語',
  ].map((value) => ({ title: value, value }));
  return (
    <>
      <dl>
        <dt>
          { /* eslint-disable-next-line jsx-a11y/label-has-associated-control */ }
          <label htmlFor="/">
            この曲には歌や声が入っていますか？（ボカロ含む）
          </label>
        </dt>
        <dd>
          <CustomRadio
            options={isInstOptions}
            value={getValue('is_inst')}
            setValue={(value) => setValue('is_inst', value)}
            validationErrors={getErrors('is_inst')}
          />
        </dd>
      </dl>
      {getValue('is_inst') === '0' && (
        <>
          <dl>
            <dt>
              { /* eslint-disable-next-line jsx-a11y/label-has-associated-control */ }
              <label htmlFor="/">
                歌詞の言語
              </label>
            </dt>
            <dd>
              <p className="text_info_on">歌詞に一番多く使われている言語を選択してください</p>
              <CustomSelect
                value={getValue('language')}
                setValue={(value) => setValue('language', value)}
                options={languageOptions}
                validationErrors={getErrors('language')}
              />
            </dd>
          </dl>
          <dl>
            <dt>
              { /* eslint-disable-next-line jsx-a11y/label-has-associated-control */ }
              <label htmlFor="/">
                歌詞内の暴力的・放送禁止用語の有無
              </label>
            </dt>
            <dd><p className="text_info_on">ありの場合、配信に制限がかかることがあります。含まれているのに「なし」を選ぶのはおやめください。</p></dd>
            <dd>
              <CustomRadio
                options={isAdultOptions}
                value={getValue('is_adult')}
                setValue={(value) => setValue('is_adult', value)}
                validationErrors={getErrors('is_adult')}
              />
            </dd>
          </dl>
        </>
      )}
    </>
  );
}
